import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Row, Column } from 'react-foundation';
import styled from 'styled-components';
import _ from 'lodash';
import { formatMsisdn } from '../../utils/helpers';
import { ApiRequest } from '../../utils/api';
import { useApiQuery } from '../../utils/apiHooks';
import { OfferingType } from '../../utils/offeringType';
import { Product } from '../../model/Products';

interface Props {
	id: string;
	msisdn: string;
	name: string;
	index: number;
	packageType?: string;
	withData: boolean;
	usedDomesticData: number;
	usedDomesticCalls: number;
	usedDomesticSms: number;
	offeringType: OfferingType;
}

const Wrapper = styled.div`
	width: 100%;
	text-align: center;
	h4 {
		font-size: 1.8em;
		font-weight: bold;
		overflow-wrap: break-word;
		display: inline-block;
		max-width: 180px;
	}
	h3 {
		font-size: 1.2em;
		font-weight: 100;
	}
`;

const Data = styled.h5`
	font-size: 1.1em;
	display: inline;
	font-weight: 600;
	overflow-wrap: break-word;
	word-break: break-word;
`;

const RightSection = styled.div`
	margin-top: 1.8em;
`;

const LeftSection = styled.div`
	margin-top: 0.4em;
`;

const Number = styled.p`
	color: #969696;
	font-size: 1.4rem;
`;

const SimRow = styled.div<{ index: number; withData: boolean }>`
	${(props) => (props.index === 0 ? 'border-top: 1px solid #eaeaea;' : '')}
	border-bottom: 1px solid #eaeaea;
	${(props) => (!props.withData ? 'overflow: auto;' : '')}
	display: flex;
	flex-direction: column;
	.sim-name {
		display: inline-block;
		word-break: break-word;
		overflow-wrap: break-word;
	}
`;

const SimListWrapper = styled.div`
	width: 100%;
	margin: auto;
	font-size: 1em;
	color: gray;
	.unmapped-sim {
		color: #979797;
	}
	span {
		text-align: left;
		color: gray;
		font-size: 1em;
		margin-top: 0.7em;
		display: inline-block;
		height: 2.5em;
		overflow-wrap: break-word;
	}
	h4 {
		text-align: center;
	}
	.red-link {
		color: red;
	}
	.no-left-padding {
		padding-left: 0;
	}
`;

export const ContactListRow: React.FC<Props> = (props: Props) => {
	// TODO better name?

	const [productPackageType, setProductPackageType] = useState<Product | undefined>(undefined);
	const { data: products } = useApiQuery(ApiRequest.getProducts(props.offeringType), { cacheTime: 60000 });

	useEffect(() => {
		if (products !== undefined) {
			setProductPackageType(products.productPackagePrices.find((product: Product) => props.packageType === product.orderItemCode));
		}
	}, [products, props.packageType]);

	return (
		<Row key={props.index}>
			{props.id && props.msisdn && props.name && (
				<SimRow index={props.index} withData>
					{props.withData && (
						<Row>
							<Wrapper>
								<Column className="small-7 columns">
									<Row>
										<Column className="small-12 large-6 columns">
											<Link to={`/account/sims/${props.id}`}>
												<h4>{props.name}</h4>
											</Link>
										</Column>
										<LeftSection>
											<Column className="small-12 large-5 columns">
												<Number>{formatMsisdn(props.msisdn)}</Number>
											</Column>
										</LeftSection>
									</Row>
								</Column>
								<Column className="small-5 columns">
									<RightSection>
										<Row>
											<Column className="small-12 large-4 columns">
												<Data>{!_.isNil(props.usedDomesticData) ? `${props.usedDomesticData.toFixed(2)} Gt ` : '–'}</Data>
											</Column>
											<Column className="small-12 large-4  columns">
												<Data>{!_.isNil(props.usedDomesticCalls) ? `${props.usedDomesticCalls} min` : '–'}</Data>
											</Column>
											<Column className="small-12  large-4 columns">
												<Data>{!_.isNil(props.usedDomesticSms) ? `${props.usedDomesticSms} kpl` : '–'}</Data>
											</Column>
										</Row>
									</RightSection>
								</Column>
							</Wrapper>
						</Row>
					)}
					{!props.withData && (
						<SimListWrapper>
							<Column large={3}>
								<Link to={`/account/sims/${props.id}`}>
									<span className={'sim-name'}>{props.name}</span>
								</Link>
							</Column>
							<Column large={2}>
								<span>{formatMsisdn(props.msisdn)}</span>
							</Column>
							<Column large={3}>{!_.isNil(productPackageType) && <span>{productPackageType.displayName}</span>}</Column>
							<Column large={4}>
								<Link to={`/account/sims/${props.id}`}>
									<span className={'red-link'}>Näytä liittymän tiedot</span>
								</Link>
							</Column>
						</SimListWrapper>
					)}
				</SimRow>
			)}
		</Row>
	);
};
